<template>
  <div>
    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="image_mobile"
      ></BannerTopMobile>
    </div>

    <div class="row justify-content-center gracias">
      <div class="col-xl-6 col-lg-6 col-md-7 col-sm-12">
        <v-card elevation="1" class="pa-2">
          <v-card-text>

            <div class="d-flex justify-content-center align-items-center color-blue font-general-r">
              <img style="width: 15%; max-width: 150px; max-height: 150px" class="mr-10 d-none d-sm-none d-md-block" src="@/assets/store/iconos/bolsa.svg" alt="">
              <div class="text-center">
                <h3>Gracias!</h3>
                <h5>Tu compra ha sido procesada exitosamente.</h5>
                <h5>Te llegará un email con los detalles de entrega.</h5>
                <h5 v-if="$route.query.dcn">
                  Gracias por decirlo con nieve, y regalarle un momento dulce a alguien.
                </h5>
                <h5 v-else>
                  Gracias por confiar en nosotros, esperamos que vuelvas pronto.
                </h5>
              </div>
            </div>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              elevation="0"
              class="nv-btn nv-btn-medium"
              @click="goHome()"
            >
              ACEPTAR
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>

    <LoadingInit :open="dialog_init"/>

  </div>
</template>

<script>
import PaymentService from '@/services/payment.service'
import { mapState } from 'vuex'
import LoadingInit from '@/components/store/LoadingInit'

export default {
  components: {LoadingInit},
  data() {
    return {
      dialog_init: false,
      image_mobile: `${process.env.VUE_APP_URL_FILES}/images/diloconnieve/mobile.jpg`,
    }
  },
  computed: {
    ...mapState(['campaign_order', 'user', 'is_auth']),
  },
  methods: {
    paymentMercadoPago(data_post) {
      this.dialog_init = true
      setTimeout(async () => {
        try {
          let route = ''
          if (this.is_auth) {
            route = 'payment-mp'
          } else {
            route = 'quick-payment-mp'
          }

          const { data:res } = await PaymentService.paymentMercadoPago(data_post, route)
          if (!res.success) {
            this.$swal(res.error, '', 'warning')
          } else {
            this.$store.dispatch('cleanCart')
            this.$store.dispatch('setPackageOrder', null)
            this.$router.replace('/confirmacion-compra')
          }
          this.dialog_init = false
        } catch (error) {
          this.dialog_init = false
        }
      }, 1500)
    },
    goHome() {
      location.href = '/'
    }
  },
  mounted() {
    if (this.$route.query.pay) {
      let status = this.$route.query.status
      if (status == 'approved' || status == 'pending') {

        let order = JSON.parse(localStorage.getItem('order_temporal'))

        let data_post = {
          payment_status: status,
          paymentID: this.$route.query.payment_id,
          discount_id: this.$route.query.dis == 'n' ? false : this.$route.query.dis,
          order: order,
          comments: order.comments
        }

        if (this.$route.query.dcn) {
          data_post.order.campaign_order = this.campaign_order
          data_post.order.date_view_dcn = this.$route.query.date_view_dcn ? this.$route.query.date_view_dcn : ''
        }

        this.paymentMercadoPago(data_post)
      } else {
        this.$swal('Ha ocurrido un error al procesar el pago, intenta de nuevo', '', 'warning')
      }
    }

    localStorage.removeItem('campaign_order')

  }
}
</script>

<style scoped>
.gracias {
  margin-top: 10%
}
@media only screen and (min-width: 360px) and (max-width: 490px) {
  .gracias {
    margin-top: 0
  }
}
</style>
